import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { apiService } from '../services/api';
import { LoadingSpinner } from '../componnents/UI';

/** Legacy /product/:productId/offers → unified marketplace inbox */
const ProductOffersRedirect = () => {
  const { productId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;

    const go = async () => {
      if (!productId) {
        navigate('/conversations', { replace: true });
        return;
      }
      try {
        const response = await apiService.ensureProductConversation(productId);
        const conv = response?.data;
        const conversationId = conv?.id || conv?._id;
        if (!cancelled) {
          navigate('/conversations', {
            replace: true,
            state: {
              conversationId: conversationId || undefined,
              productId,
              openOffer: true,
            },
          });
        }
      } catch (err) {
        const code = err?.response?.data?.code || err?.code;
        if (code === 'OWN_STORE') {
          if (!cancelled) {
            navigate('/conversations', { replace: true });
          }
          return;
        }
        console.warn('Product conversation redirect failed:', err);
        if (!cancelled) {
          navigate('/conversations', {
            replace: true,
            state: { productId, openOffer: true },
          });
        }
      }
    };

    go();
    return () => {
      cancelled = true;
    };
  }, [productId, navigate]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '3rem' }}>
      <LoadingSpinner />
    </div>
  );
};

export default ProductOffersRedirect;
